



































































import { LongevityBoard } from '@/models/CeremonyFormModel';
import Vue from 'vue';

export default Vue.extend({
  props: {
    checkMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      longevity: [
        new LongevityBoard(''),
      ],
    };
  },
  computed: {
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.longevity = this.$store.state.form.ceremonyForm.longevityBoards;
    },
    clearData() {
      this.$notify({
        type: 'info',
        title: '已清空資料',
      });
      this.longevity = [
        new LongevityBoard(''),
      ];
      this.$store.commit('updateLongevity', this.longevity);
    },
    addPerson() {
      this.longevity.push(new LongevityBoard(''));
    },
    deletePerson(key: number) {
      this.longevity.splice(key, 1);
    },
    goStep(move: string) {
      if (move === 'last') {
        this.$router.push('personalInformation');
      }
      if (move === 'next') {
        this.$router.push('prayFor');
      }
    },
  },
});
